import { render, staticRenderFns } from "./delete-confirmation.vue?vue&type=template&id=5df5dc57&scoped=true"
import script from "./delete-confirmation.vue?vue&type=script&lang=js"
export * from "./delete-confirmation.vue?vue&type=script&lang=js"
import style0 from "./delete-confirmation.vue?vue&type=style&index=0&id=5df5dc57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df5dc57",
  null
  
)

export default component.exports